import { useEffect } from 'react';

const useReplayOnScrollReveal = (
  selector,
  visibleClassName,
  threshold = 0.08,
  rootMargin = '80px 0px -8% 0px',
  once = false,
  leaveDelayMs = 0
) => {
  useEffect(() => {
    const nodes = document.querySelectorAll(selector);
    if (!nodes.length) return undefined;
    const leaveTimers = new Map();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const pendingLeave = leaveTimers.get(entry.target);
          if (pendingLeave) {
            window.clearTimeout(pendingLeave);
            leaveTimers.delete(entry.target);
          }

          if (entry.isIntersecting) {
            entry.target.classList.add(visibleClassName);
            if (once) observer.unobserve(entry.target);
          } else {
            if (!once) {
              if (leaveDelayMs > 0) {
                const timerId = window.setTimeout(() => {
                  entry.target.classList.remove(visibleClassName);
                  leaveTimers.delete(entry.target);
                }, leaveDelayMs);
                leaveTimers.set(entry.target, timerId);
              } else {
                entry.target.classList.remove(visibleClassName);
              }
            }
          }
        });
      },
      { threshold, rootMargin }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => {
      observer.disconnect();
      leaveTimers.forEach((timerId) => window.clearTimeout(timerId));
      leaveTimers.clear();
    };
  }, [selector, visibleClassName, threshold, rootMargin, once, leaveDelayMs]);
};

export default useReplayOnScrollReveal;
